/*
The Glow Intelligence symbol: the Lattice variant from the design exploration. A parcel
drawn as an edge graph with a center node and waypoint dots on the vertices. Rides on
currentColor, so it inherits the surrounding text color.
*/
export const AiLogo = ({ size = 24, className }: { size?: number; className?: string }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    aria-hidden
    className={className ? `block ${className}` : 'block'}
  >
    <g fill="none" stroke="currentColor" strokeWidth={3.4} strokeLinejoin="round" strokeLinecap="round">
      <path d="M32 7 L54 19.5 L54 44.5 L32 57 L10 44.5 L10 19.5 Z" />
      <path d="M10 19.5 L32 32 L54 19.5 M32 32 L32 57" opacity={0.45} />
    </g>
    <circle cx={32} cy={32} r={4.5} fill="currentColor" />
    <circle cx={32} cy={7} r={3.2} fill="currentColor" />
    <circle cx={54} cy={19.5} r={3.2} fill="currentColor" />
    <circle cx={10} cy={44.5} r={3.2} fill="currentColor" />
  </svg>
)
